import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class CalibresView extends Component {
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var tipoFruta_Id = rawUrl.split("TiposFruta/")[1].split("/")[0];
        this.state = {
            operation: props.operation
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = {tipoFruta_Id: tipoFruta_Id, valor: "" };
        }
        console.log(" this.state.model", this.state.model)
        this.state.modelValidation = {
            valor: this.state.model.valor != ""
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }

    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/calibres/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <FormGroup>
                            <Label for="Valor">
                                <FormattedMessage id='Valor' />
                            </Label>
                            <FormattedMessage id='Valor'>
                                {(placeholder) =>
                                    <Input
                                        id="valor"
                                        name="valor"
                                        placeholder={placeholder}
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.valor}
                                        valid={this.getValidationValue(this.state.modelValidation.valor)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.valor)}
                                    />
                                }
                            </FormattedMessage>
                            <FormFeedback>
                                {this.state.model.valor == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este valor ya esta siendo usado' />}
                            </FormFeedback>
                        </FormGroup>
                    </Form>
                </Row>
            </div>
        );
    }

}